var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGitlab = function SvgGitlab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gitlab_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F2ED",
    d: "M12.454.188h-8.5a3.75 3.75 0 0 0-3.75 3.75v8.5a3.75 3.75 0 0 0 3.75 3.75h8.5a3.75 3.75 0 0 0 3.75-3.75v-8.5a3.75 3.75 0 0 0-3.75-3.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "m8.203 13.938 2.348-7.074H5.856z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M8.203 13.938 5.856 6.864h-3.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "m2.566 6.863-.714 2.15a.47.47 0 0 0 .177.532l6.174 4.393z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M2.566 6.863h3.29l-1.414-4.26c-.073-.22-.39-.22-.462 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "m8.203 13.938 2.348-7.074h3.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "m13.841 6.863.714 2.15a.47.47 0 0 1-.177.532l-6.175 4.393z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M13.841 6.863h-3.29l1.414-4.26c.073-.22.39-.22.462 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gitlab_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.203.188h16v16h-16z"
  })))));
};
export default SvgGitlab;